import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: theme.shape.borderRadius * 2.4, // 20% more rounded
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
  dialogTitle: {
    fontSize: '2rem', // 100% increase from default
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  dialogContent: {
    '& .MuiDialogContentText-root': {
      fontSize: '1.75rem', // 100% increase from default
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
  confirmButton: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '1rem',
    textTransform: 'none',
  },
  cancelButton: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '1rem',
    textTransform: 'none',
  },
}))

interface ConfirmationModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  isLoading?: boolean
  loadingText?: string
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false,
  loadingText,
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      onClick={(e) => e.stopPropagation()}
      className={classes.dialog}
    >
      <DialogTitle id="confirmation-dialog-title" className={classes.dialogTitle}>
        {title}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary" 
          disabled={isLoading}
          variant="outlined"
          className={classes.cancelButton}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="primary" 
          autoFocus 
          disabled={isLoading}
          variant="contained"
          className={classes.confirmButton}
        >
          {isLoading && loadingText ? loadingText : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
